import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

export const useDeletePrintExtraction: MutationFunction<
  null,
  { printExtractionUuid: string },
  []
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: ({ printExtractionUuid }: { printExtractionUuid: string }) =>
      request(`/parts/${printExtractionUuid}/print_extraction`, {
        init: { method: 'DELETE' },
      }),
    ...queryOptions,
    mutationKey: ['delete', 'printExtraction'],
  });
};
